import { render } from "./ArchiveGoalPrompt.vue?vue&type=template&id=29763330&scoped=true"
import script from "./ArchiveGoalPrompt.vue?vue&type=script&lang=js"
export * from "./ArchiveGoalPrompt.vue?vue&type=script&lang=js"

import "./ArchiveGoalPrompt.vue?vue&type=style&index=0&id=29763330&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-29763330"

export default script